/* Package JSON Import will be here */
import React from "react";
import _ from "lodash";
import { notification, Avatar, Image } from "antd";
import { Link } from "react-router-dom";
import { Button } from "antd";
import CryptoJS from "crypto-js";
import { isMobile } from 'react-device-detect';
/* Package JSON Import will be here */

/* Project Import will be here */
import Constants from "./appConstants";
import notificationSound from "../assets/sound/notification.mp3";
import { appRoutesConst } from "app/navigation";
import { dispatchInstance } from "reducers/common/appSettings";
import { push } from "connected-react-router";
import filePdf from "assets/img/file-pdf.png";
import fileWord from "assets/img/file-word.png";
import fileExcel from "assets/img/file-excel.png";
import filePpt from "assets/img/file-ppt.png";
import fileTxt from "assets/img/file-txt.png";
/* Project Import will be here */

export const getErrorObject = (error) => {
  let message = "Error!";
  let errorCode = "";
  let data = "";

  if (error && error.data) {
    if (error.data.Code)
      errorCode = error.data.Code;

    if (error.data.Msg)
      message = error.data.Msg;

    if (error.data.Data)
      data = error.data.Data;
  }
  else if (error && error.message) {
    /* js error message */
    message = error.message;
  }

  return ({ message, errorCode, data });
};

export const getSuccessObject = success => {
  let message = "";
  let successCode = "";

  if (success && success.data && success.data.Code)
    successCode = success.data.Code;

  if (success && success.data && success.data.Msg)
    message = success.data.Msg;

  return ({ message, successCode });
}

/* Display error toast message */
export const errorToast = ({ content = "" }) => {
  notification["error"]({
    message: content,
    duration: 5,
    style: {
      backgroundColor: "#fff2f0",
      border: "1px solid #ffccc7",
      borderRadius: "1.5rem"
    }
  });
};

/* Display success toast message */
export const successToast = ({ content = "" }) => {
  notification["success"]({
    message: content,
    duration: 4,
    style: {
      backgroundColor: "#f6ffed",
      border: "1px solid #b7eb8f",
      borderRadius: "1.5rem"
    }
  });
};

/* Display info toast message */
export const infoToast = ({ content = "" }) => {
  notification["info"]({
    message: content,
    duration: 4,
    style: {
      backgroundColor: "#edeff2",
      border: "1px solid #49acde",
      borderRadius: "1.5rem"
    }
  });
};

/* Display info toast message */
export const warningToast = ({ content = "" }) => {
  notification["warning"]({
    message: content,
    duration: 4,
    style: {
      backgroundColor: "#f2f1ed",
      border: "1px solid #f9b42b",
      borderRadius: "1.5rem"
    }
  });
};

/* Display fcm toast message */
export const fcmNotificationToast = ({ title = "", content = "", bannerImageUrl = "", redirectUrl = "" }) => {
  const notificationContent = (<div>
    <div>{content}</div>

    {bannerImageUrl !== "" &&
      <Image
        className="push-notification-banner"
        src={bannerImageUrl}
        preview={false}
      />
    }
  </div>);

  const key = `open${Date.now()}`;

  const onClickFcmMessage = (redirectUrl) => {
    if (redirectUrl !== "" && dispatchInstance !== null) {
      /* eslint-disable no-useless-escape */
      const pathLocation = redirectUrl.replace(/^.*\/\/[^\/]+/, '');

      dispatchInstance(push(pathLocation));
      notification.close(key)
    }
  }

  notification.open({
    message: title,
    description: notificationContent,
    duration: 5,
    icon: <Avatar style={{ backgroundColor: '#87d068' }} icon={<i className="fa fa-bell animate-ring" aria-hidden="true"></i>} />,
    style: {
      backgroundColor: "#edeff2",
      border: "1px solid #49acde",
      borderRadius: "1.5rem"
    },
    onClick: () => onClickFcmMessage(redirectUrl),
    key
  });

  const audio = new Audio(notificationSound);
  audio.play();
};

export const normalize = ({ data, key }) => {
  let obj = {};
  let ids = [];
  data.forEach(element => {
    obj[element[key]] = element;
    ids.push(element[key]);
  });
  return { data: obj, ids };
};

export const normalizeByGroup = ({ data, key, groupKey }) => {
  /* Object initialization */
  let obj = {};
  let ids = [];
  let group = {};
  let groupIds = new Set();

  data.forEach(element => {
    obj[element[key]] = element;
    groupIds.add(element[groupKey]);
    if (!group[element[groupKey]]) {
      group[element[groupKey]] = [];
    }
    group[element[groupKey]].push(element[key]);
    ids.push(element[key]);
  });
  return { data: obj, ids, groupIds: [...groupIds], group };
};

/* Manage multiple scheme products */
export const mergeMultipleSchemeProducts = (data) => {
  let schemeMergedProductList = [];

  _.forEach(data, o => {
    /* Initially add empty SchemeList array in the response object */
    o.SchemeList = [];
    o.DiscountList = [];

    if (o.SchemeId !== 0) {
      let existProduct = _.find(schemeMergedProductList, a => { return a.ProductId === o.ProductId });
      if (existProduct === undefined) {
        o.SchemeList.push({ 'SchemeId': o.SchemeId, 'Scheme': o.Scheme });
        schemeMergedProductList.push(o);
      }
      else {
        existProduct.SchemeList.push({ 'SchemeId': o.SchemeId, 'Scheme': o.Scheme });
      }
    }
    else if (o.DiscountId !== 0) {
      let existProduct = _.find(schemeMergedProductList, a => { return a.ProductId === o.ProductId });
      if (existProduct === undefined) {
        o.DiscountList.push({ 'DiscountId': o.DiscountId, 'DiscAmount': o.DiscAmount });
        schemeMergedProductList.push(o);
      }
      else {
        existProduct.DiscAmount = existProduct.DiscAmount + o.DiscAmount;
        existProduct.DiscountList.push({ 'DiscountId': o.DiscountId, 'DiscAmount': o.DiscAmount });
      }
    }
    else {
      schemeMergedProductList.push(o);
    }
  });

  return schemeMergedProductList;
};

/* Reward points to cash converter */
export const convertPointsToCurrency = (points, conversionRate) => {
  return points * conversionRate;
};

/* Merge multiple scheme in order summary page */
export const mergeMultipleSchemeOrderSummary = (data) => {
  let schemeMergedOrderList = [];

  _.forEach(data, o => {
    /* Initially add empty SchemeList array in the response object */
    o.SchemeList = [];
    o.DiscountList = [];

    if (o.SchemeId !== 0) {
      let existProduct = _.find(schemeMergedOrderList, a => { return a.ProductId === o.ProductId });
      if (existProduct === undefined) {
        o.SchemeList.push({ 'SchemeId': o.SchemeId, 'SchemeAmount': o.SchemeAmount });
        schemeMergedOrderList.push(o);
      }
      else {
        existProduct.SchemeAmount = existProduct.SchemeAmount + o.SchemeAmount;
        existProduct.SchemeList.push({ 'SchemeId': o.SchemeId, 'SchemeAmount': o.SchemeAmount });
      }
    }
    else if (o.DiscountId !== 0) {
      let existProduct = _.find(schemeMergedOrderList, a => { return a.ProductId === o.ProductId });
      if (existProduct === undefined) {
        o.DiscountList.push({ 'DiscountId': o.DiscountId, 'DiscAmount': o.DiscAmount });
        schemeMergedOrderList.push(o);
      }
      else {
        existProduct.DiscAmount = existProduct.DiscAmount + o.DiscAmount;
        existProduct.DiscountList.push({ 'DiscountId': o.DiscountId, 'DiscAmount': o.DiscAmount });
      }
    }
    else {
      schemeMergedOrderList.push(o);
    }
  });

  return schemeMergedOrderList;
};

export const normalizeMenu = ({ data, key, groupKeys }) => {
  let obj = {};
  let ids = [];
  let groups = {};
  data.forEach(element => {
    obj[element[key]] = element;
    if (groupKeys) {
      groupKeys.forEach(groupKey => {
        if (!groups[groupKey]) {
          groups[groupKey] = {};
        }
        if (!groups[groupKey][element[groupKey]]) {
          groups[groupKey][element[groupKey]] = [];
        }
        groups[groupKey][element[groupKey]].push(element[key]);
      });
    }
    ids.push(element[key]);
  });
  return { data: obj, ids, groups };
};

export const normalizeCategoryMenu = response => {
  let normalizedData = {};
  normalizedData.BR = normalizeMenu({
    data: response.brands,
    key: "id",
    groupKeys: ["catId", "subcatId"]
  });
  normalizedData.SUCAT = normalizeMenu({
    data: response.subcategories,
    key: "id",
    groupKeys: ["catId"]
  });
  normalizedData.CAT = normalizeMenu({
    data: response.categories,
    key: "id"
  });

  return normalizedData;
};

/* Get specific sub-category products object creation */
export const subCategoryRequest = ({ id, filterType }) => {
  return {
    FilterIdList: id,
    FilterLevelCode: "SUCAT",
    NeedScheme: filterType === Constants.SCHEME ? true : false,
    NeedOpportunity: filterType === Constants.OPPORTUNITY ? true : false,
    NeedRelevant: filterType === Constants.RELEVANT ? true : false
  };
};

/* Get specific category products object creation */
export const categoryRequest = ({ id, filterType }) => {
  return {
    FilterIdList: id,
    FilterLevelCode: "CAT",
    NeedScheme: filterType === Constants.SCHEME ? true : false,
    NeedOpportunity: filterType === Constants.OPPORTUNITY ? true : false,
    NeedRelevant: filterType === Constants.RELEVANT ? true : false
  };
};

/* Get currency symbols */
export const currencySymbol = (window.currencySymbol !== undefined && window.currencySymbol !== "") ? window.currencySymbol : Constants.CURRENCY_INR;

/* Validate the Wholesaler is present or not */
export const wholesalerValidator = localStore => {
  if (localStore.selectedWholesaler) {
    return true;
  }
  return false;
};

/* Validate the Wholesaler is present or not */
export const validateWholesaler = (props, callback) => {
  if (props.localStore.selectedWholesaler) {
    callback();
  }
  else {
    errorToast({ content: props.translate("wholesaler.error.wholesalerValidationMsg") });
  }
};

export const getDayNameFromDay = (daySequenceNumber: number) => {
  return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][daySequenceNumber]
}

export const checkEligibleForFoc = (orders, nonFocToFoc) => {
  const selectedData = _.filter(orders.data, (o) => {
    return o.count !== 0 || o.case_count !== 0;
  });

  if (selectedData === undefined || selectedData.length === 0) {
    return true;
  }
  else {
    const isDataExist = _.find(selectedData, (o) => { return o.isSaleable === nonFocToFoc });

    if (isDataExist !== undefined) {
      return false;
    }
    else {
      return true;
    }
  }
}

export const checkAnyFocProductsAddedInCart = (cart) => {
  /* Check if any FOC products added in the cart */
  const anyFocProductsAddedInCart = _.filter(cart, (o) => {
    return !o.IsSaleable;
  });

  if (anyFocProductsAddedInCart !== undefined && anyFocProductsAddedInCart.length > 0) {
    return true;
  }
  else {
    return false;
  }
}

export const checkAnyNonFocProductsAddedInCart = (cart) => {
  /* Check if any FOC products added in the cart */
  const anyNonFocProductsAddedInCart = _.filter(cart, (o) => {
    return o.IsSaleable;
  });

  if (anyNonFocProductsAddedInCart !== undefined && anyNonFocProductsAddedInCart.length > 0) {
    return true;
  }
  else {
    return false;
  }
}

/* Get the selected order summary filter level code and value */
export const getNameByOrderSummaryFilterLevelCode = (filterLevelCode) => {
  const nameCodeKeyValuePair = [
    { key: "BR", value: "brand" },
    { key: "CAT", value: "category" },
    { key: "SUCAT", value: "subcategory" },
    { key: "SUBR", value: "subBrand" },
    { key: "SKU", value: "sku" }
  ];

  const selectedValue = _.filter(nameCodeKeyValuePair, (o) => {
    return o.key === filterLevelCode;
  });

  if (selectedValue !== undefined && selectedValue.length > 0) {
    return selectedValue[0].value;
  }
  else {
    return null;
  }
}

/* Convert the S3 image URL into static file URL */
export const getStaticFileImageUrl = (s3ImageUrl, awsConfig) => {
  const splittedUrl = s3ImageUrl.split(awsConfig.DirectoryAccess);
  const updatedUrl = awsConfig.StaticUrl + splittedUrl[1];

  return updatedUrl;
}

/* Image media type check - Currently the image uploader in all the places only accept PNG, JPG and JPEG image types */
export const checkImageFormat = (format) => {
  const acceptFormat = [
    "image/png",
    "image/jpeg",
    "image/jpg"
  ];

  return _.includes(acceptFormat, format);
}

/* Get proper retailer address text */
export const getAddressText = (addr) => {
  let addressString = "";

  const address1 = addr.Address1 !== null ? addr.Address1.trim() : "";
  if (address1 !== "")
    addressString = addressString + address1;

  const address2 = addr.Address2 !== null ? addr.Address2.trim() : "";
  if (address2 !== "")
    addressString = addressString + (", " + address2)

  const city = addr.City !== null ? addr.City.trim() : "";
  if (city !== "")
    addressString = addressString + (", " + city)

  const state = addr.State !== null ? addr.State.trim() : "";
  if (state !== "")
    addressString = addressString + (", " + state)

  const country = addr.Country !== null ? addr.Country.trim() : "";
  if (country !== "")
    addressString = addressString + (", " + country)

  const zip = addr.Zip !== null ? addr.Zip.trim() : "";
  if (zip !== "")
    addressString = addressString + (", " + zip)

  return addressString;
}

/* Form the today date with yyyy-mm-dd format */
export const getTodayDateWithYearMonthDateFormat = () => {
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  today = `${yyyy}-${mm}-${dd}`;

  return today;
}

/* Get cart total value information */
export const getCartPriceDetails = (products) => {
  let totalPriceWitTax = 0;
  let totalEffectivePrice = 0;
  let totalTaxAmount = 0;
  let totalDiscount = 0;

  for (let key in products) {
    const product = products[key];
    const qty = product.caseQTY * product.ConversionQty + product.pieceQTY;
    const priceWithOutTax = product.OldPrice * qty;
    const discountPrice = product.DiscAmount + product.SchemeAmount;
    const effectivePrice = ((priceWithOutTax - discountPrice) + product.TaxAmount);

    totalEffectivePrice += effectivePrice;
    totalPriceWitTax += product.Price * qty;
    totalTaxAmount += product.TaxAmount;
    totalDiscount += discountPrice;
  }

  return { totalEffectivePrice, totalPriceWitTax, totalTaxAmount, totalDiscount };
}

export const getDMSErrorSection = (translate) => {
  return (
    <div className="dms-authentication-error">
      <i className="fa fa-exclamation-circle fa-3x" aria-hidden="true"></i>
      <p>{translate("common.placeholder.errorInAuthentication")}</p>
      <Link to={appRoutesConst.productList}>
        <Button type="primary" shape="round">
          {translate("common.buttons.gotoPlaceOrder")}
        </Button>
      </Link>
    </div>
  )
}

export const getCurrentPageTitle = (pageRoute, isFromGATracking, translate) => {
  if (isFromGATracking) {
    let pageTitle = "";

    switch (pageRoute) {
      case appRoutesConst.index:
        pageTitle = "IVY Marketplace";
        break;
      case appRoutesConst.orderSummary:
        pageTitle = `IVY Marketplace - ${translate("common.links.myCart")}`;
        break;
      case appRoutesConst.checkout:
        pageTitle = `IVY Marketplace - ${translate("common.links.checkOut")}`;
        break;
      case appRoutesConst.productList:
        pageTitle = `IVY Marketplace - ${translate("common.links.placeOrder")}`;
        break;
      case appRoutesConst.home:
        pageTitle = `IVY Marketplace - ${translate("common.links.home")}`;
        break;
      case appRoutesConst.smartList:
        pageTitle = `IVY Marketplace - ${translate("common.links.orderBySmartList")}`;
        break;
      case appRoutesConst.profile:
        pageTitle = `IVY Marketplace - ${translate("common.links.profile")}`;
        break;
      case appRoutesConst.changeMobileNumber:
        pageTitle = `IVY Marketplace - ${translate("common.links.ChangeMobileNumber")}`;
        break;
      case appRoutesConst.settings:
        pageTitle = `IVY Marketplace - ${translate("common.links.settings")}`;
        break;
      case appRoutesConst.orderHistory:
        pageTitle = `IVY Marketplace - ${translate("common.links.orders")}`;
        break;
      case appRoutesConst.manageWholesalers:
        pageTitle = `IVY Marketplace - ${translate("common.links.manageDistributors")}`;
        break;
      case appRoutesConst.favProducts:
        pageTitle = `IVY Marketplace - ${translate("common.links.orderByFavourite")}`;
        break;
      case appRoutesConst.promotions:
        pageTitle = `IVY Marketplace - ${translate("common.links.promotionList")}`;
        break;
      case appRoutesConst.notification:
        pageTitle = `IVY Marketplace - ${translate("common.links.notifications")}`;
        break;
      case appRoutesConst.digitalContent:
        pageTitle = `IVY Marketplace - ${translate("common.links.digitalContent")}`;
        break;
      case appRoutesConst.myComplaints:
        pageTitle = `IVY Marketplace - ${translate("common.links.myComplaints")}`;
        break;
      case appRoutesConst.kpiDashboard:
        pageTitle = `IVY Marketplace - ${translate("common.links.kpiDashboard")}`;
        break;
      case appRoutesConst.salesReturn:
        pageTitle = `IVY Marketplace - ${translate("common.links.salesReturn")}`;;
        break;
      case appRoutesConst.salesReturnSummary:
        pageTitle = "IVY Marketplace - Sales Return Summary";
        break;
      case appRoutesConst.resetPassword:
        pageTitle = `IVY Marketplace - ${translate("common.links.resetPassword")}`;;
        break;
      case appRoutesConst.storeDashboard:
        pageTitle = `IVY Marketplace - ${translate("common.links.storeDashboard")}`;
        break;
      case appRoutesConst.consumer:
        pageTitle = `IVY Marketplace - ${translate("common.links.storeConsumers")}`;
        break;
      case appRoutesConst.storeProducts:
        pageTitle = "IVY Marketplace - Store Products";
        break;
      case appRoutesConst.storeDisplay:
        pageTitle = "IVY Marketplace - Store Display";
        break;
      case appRoutesConst.myPayment:
        pageTitle = `IVY Marketplace - ${translate("common.links.myPayment")}`;
        break;
      case appRoutesConst.paymentDetails:
        pageTitle = `IVY Marketplace - ${translate("common.links.paymentDetails")}`;
        break;
      case appRoutesConst.paymentResponse:
        pageTitle = `IVY Marketplace - ${translate("common.links.paymentResponse")}`;
        break;
      case appRoutesConst.orderStatusDelivery:
        pageTitle = `IVY Marketplace - ${translate("common.links.deliveryConfirmation")}`;
        break;
      case appRoutesConst.salesReturnHistory:
        pageTitle = `IVY Marketplace - ${translate("common.links.salesReturnHistory")}`;
        break;
      case appRoutesConst.retailerLedger:
        pageTitle = `IVY Marketplace - ${translate("common.links.retailerLedger")}`;
        break;
      case appRoutesConst.qpsSchemes:
        pageTitle = `IVY Marketplace - ${translate("common.links.qpaSchemes")}`;
        break;
      case appRoutesConst.exchangeReturn:
        pageTitle = `IVY Marketplace - ${translate("common.links.exchangeReturn")}`;
        break;
      case appRoutesConst.cancelOrder:
        pageTitle = `IVY Marketplace - ${translate("common.links.cancelOrder")}`;
        break;
      case appRoutesConst.supportHelpline:
        pageTitle = `IVY Marketplace - ${translate("common.links.supportHelpline")}`;;
        break;
      case appRoutesConst.myRewards:
        pageTitle = `IVY Marketplace - ${translate("common.links.myRewards")}`;;
        break;
      case appRoutesConst.rewardHistory:
        pageTitle = `IVY Marketplace - ${translate("common.links.redemptionHistory")}`;;
        break;
      case appRoutesConst.appGuidance:
        pageTitle = `IVY Marketplace - ${translate("common.links.appGuidance")}`;;
        break;
      case appRoutesConst.clubEnrollment:
        pageTitle = `IVY Marketplace - ${translate("common.links.clubEnrollment")}`;;
        break;
      case appRoutesConst.myEarningsLedger:
        pageTitle = `IVY Marketplace - ${translate("common.links.myEarningsLedger")}`;
        break;
      case appRoutesConst.survey:
        pageTitle = `IVY Marketplace - ${translate("common.links.survey")}`;
        break;
      default:
        {
          if (pageRoute.includes(`${appRoutesConst.orderHistoryDetails}/`)) {
            pageTitle = `IVY Marketplace - ${translate("common.links.orderDetails")} - ${pageRoute.split("/")[3]}`;
          }
          else if (pageRoute.includes(`${appRoutesConst.rewardsHistoryDetails}/`)) {
            pageTitle = `IVY Marketplace - Redemption History Details - ${pageRoute.split("/")[3]}`;
          }
          else if (pageRoute.includes(`${appRoutesConst.products}/`)) {
            const category = pageRoute.split("/")[3];
            const subcategory = pageRoute.split("/")[4];
            const catAndSubCatString = (category + (subcategory !== undefined ? ` - ${subcategory}` : ""));
            pageTitle = `IVY Marketplace - ${translate("common.links.placeOrder")} - ${catAndSubCatString}`;
          }
          else if (pageRoute.includes(`${appRoutesConst.promotionDetails}/`)) {
            pageTitle = `IVY Marketplace - Promotion Details - ${pageRoute.split("/")[3]}`;
          }
          else if (pageRoute.includes(`${appRoutesConst.viewAllProducts}/`)) {
            pageTitle = `IVY Marketplace - ${translate("common.links.viewAllProducts")} - ${pageRoute.split("/")[3]}`;
          }
          else if (pageRoute.includes(`${appRoutesConst.salesReturnProducts}/`)) {
            const category = pageRoute.split("/")[3];
            const subcategory = pageRoute.split("/")[4];
            const catAndSubCatString = (category + (subcategory !== undefined ? ` - ${subcategory}` : ""));
            pageTitle = `IVY Marketplace - Sales Return Product List - ${catAndSubCatString}`;
          }
          else if (pageRoute.includes(`${appRoutesConst.salesReturnHistoryDetails}/`)) {
            pageTitle = `IVY Marketplace - Sales Return History Details - ${pageRoute.split("/")[3]}`;
          }
          else if (pageRoute.includes(`${appRoutesConst.exchangeReturnResult}/`)) {
            pageTitle = `IVY Marketplace - Exchange Return Result - ${pageRoute.split("/")[3]} - ${pageRoute.split("/")[4]} - ${pageRoute.split("/")[5]} - ${pageRoute.split("/")[6]}`;
          }
          else {
            pageTitle = `IVY Marketplace - ${pageRoute}`;
          }
        }
    }

    return pageTitle;
  }
  else {
    return window.clientAppName;
  }
}

/* Get order volume display volume */
export const getOrderVolumeByConversionRate = (appSettings, value) => {
  const multiplyOperand = parseFloat(appSettings.orderVolumeConversionCode, 10);
  return `${(value * multiplyOperand).toFixed(2)} ${appSettings.orderVolumeMetric}`;
}

/* Check for file is video banner */
export const checkFileTypeIsVideo = (file) => {
  if (file.FileType === Constants.MEDIA_TYPE_MOV || file.FileType === Constants.MEDIA_TYPE_MP4)
    return true;
  else
    return false
}

/* Check for banner is image banner */
export const checkFileTypeIsImage = (file) => {
  if (file.FileType === Constants.MEDIA_TYPE_PNG || file.FileType === Constants.MEDIA_TYPE_JPG || file.FileType === Constants.MEDIA_TYPE_JPEG || file.FileType === Constants.MEDIA_TYPE_GIF || file.FileType === Constants.MEDIA_TYPE_TIFF)
    return true;
  else
    return false
}

export const getImageBasedOnFileType = (item) => {
  if (item.FileType === Constants.MEDIA_TYPE_PDF) {
    return filePdf;
  }
  else if (item.FileType === Constants.MEDIA_TYPE_PPT || item.FileType === Constants.MEDIA_TYPE_PPTX) {
    return filePpt;
  }
  else if (item.FileType === Constants.MEDIA_TYPE_DOCX || item.FileType === Constants.MEDIA_TYPE_DOC) {
    return fileWord;
  }
  else if (item.FileType === Constants.MEDIA_TYPE_TXT) {
    return fileTxt;
  }
  else if (item.FileType === Constants.MEDIA_TYPE_XLS || item.FileType === Constants.MEDIA_TYPE_CSV || item.FileType === Constants.MEDIA_TYPE_XLSX || item.FileType === Constants.MEDIA_TYPE_ODS) {
    return fileExcel;
  }
  else if (item.FileType === Constants.MEDIA_TYPE_MP4 || item.FileType === Constants.MEDIA_TYPE_MOV) {
    return item.Thumbnail;
  }
  else
    return item.FileUrl;
}

/* Image compression */
export const getImgCompressionQuality = (file) => {
  const fileSizeMB = file.size / (1024 * 1024);

  let compressionQuality;

  if (fileSizeMB >= 1)
    compressionQuality = 0.2;
  else
    compressionQuality = 0.6;

  return compressionQuality;
};

/* Accept only these image extension */
export const isImageExtension = (format) => {
  const acceptImageFormats = [
    ".png",
    ".jpeg",
    ".jpg"
  ];

  return _.includes(acceptImageFormats, format.toLowerCase());
};

export const getResObj = (awsConfig) => {
  const yek = "a90b65e5d02e4cfab42a17a9cd81c2b3";
  const vi = "6829103475918042";

  /* Reverse special character replacements */
  let base64String = awsConfig
    .replace(/-/g, "+") /* Replace '-' with '+' */
    .replace(/_/g, "/"); /* Replace '_' with '/' */

  /* Add padding if necessary */
  while (base64String.length % 4 !== 0) {
    base64String += "=";
  }

  /* Parse Base64 string into bytes */
  const encryptedBytes = CryptoJS.enc.Base64.parse(base64String);

  /* Decrypt the bytes */
  const decryptedBytes = CryptoJS.AES.decrypt(
    { ciphertext: encryptedBytes },
    CryptoJS.enc.Utf8.parse(yek),
    { iv: CryptoJS.enc.Utf8.parse(vi), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  /* Convert decrypted bytes to UTF-8 string */
  const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

  /* Parse and return the JSON object */
  return JSON.parse(decryptedText);
};

export const getCultureNumberFormat = (number, needCurrencySymbol = false, applyRound = false) => {
  let inputNumber = applyRound ? Math.round(number) : number;

  if (window.cultureNumberFormat !== "") {
    const formatOptions = applyRound ? {} : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    inputNumber = new Intl.NumberFormat(window.cultureNumberFormat, formatOptions).format(inputNumber);
  }

  return needCurrencySymbol ? currencySymbol + inputNumber : inputNumber;
};

/* Get current device info */
export const getDeviceInfo = () => {
  return navigator.userAgent;
}

/* Check for mobile devices to take photo */
export const isMobileDevice = () => {
  return isMobile;
};

/* Check is IOS device */
export const isIosDevice = () => {
  return /iphone|ipad|ipod|macintosh/.test(window.navigator.userAgent.toLowerCase());
};

/* Hard refresh the app */
export const emptyCacheAndReloadApp = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      /* Clear the service worker cache */
      caches.keys().then(function (cacheNames) {
        cacheNames.forEach(function (cacheName) {
          caches.delete(cacheName);
        });
      });

      /* Unregister the service worker */
      for (let registration of registrations) {
        registration.unregister();
      }
    }).catch(function (error) {
      console.log('Service Worker registration failed: ', error);
    }).finally(() => {
      window.location.reload(true);
    });
  }
  else
    window.location.reload(true);
}

export const getFormattedDateTime = () => {
  const now = new Date();
  const pad = (num) => String(num).padStart(2, '0');

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1);
  const year = now.getFullYear();

  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  return `${day}-${month}-${year} ${hours}-${minutes}-${seconds}`;
}